import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { SystemSetting } from './system-setting.model';
import { ResponseWrapper, createRequestOption } from '../../shared';
import { API } from '../../shared/constants/api.constants';

@Injectable()
export class SystemSettingService {

    private resourceUrl = API.host + 'systemSettings';
    private resourceUpdateUrl = API.host + 'systemSettings/updateSystemSettings';
    private resourceGetAll = API.host + 'systemSettings/base';

    constructor(private http: Http) { }

    // create(systemSetting: SystemSetting): Observable<SystemSetting> {
    //     const copy = this.convert(systemSetting);
    //     return this.http.post(this.resourceUrl, copy).map((res: Response) => {
    //         if (!res || !res.json) {
    //             throw 'Invalid Code';
    //         }

    //         return res.json().data;
    //     });
    // }

    // update(systemSetting: SystemSetting): Observable<SystemSetting> {
    //     const copy = this.convert(systemSetting);
    //     return this.http.post(`${this.resourceUpdateUrl}/${systemSetting.id}`, copy).map((res: Response) => {
    //         if (!res || !res.json) {
    //             throw 'Invalid Code';
    //         }

    //         return res.json().data;
    //     });
    // }

    find(): Observable<SystemSetting> {
        return this.http.get(`${this.resourceUrl}`).map((res: Response) => {
            if (!res || !res.json) {
                throw 'Invalid request';
            }

            return res.json().data;
        });
    }

    getBase(): Observable<SystemSetting> {
        return this.http.get(`${this.resourceUrl}/base`).map((res: Response) => {
            if (!res || !res.json) {
                throw 'Invalid request';
            }

            return res.json().data;
        });
    }

    query(req?: any): Observable<ResponseWrapper> {
        const options = createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map((res: Response) => this.convertResponse(res));
    }

    // delete(id: number): Observable<Response> {
    //     return this.http.delete(`${this.resourceUrl}/${id}`).map((res: Response) => {
    //         if (!res || !res.json) {
    //             throw 'Invalid Code';
    //         }

    //         return res.json().data;
    //     });
    // }

    private convertResponse(res: Response): any {
        if (!res || !res.json) {
            throw 'Invalid Code';
        }

        const jsonResponse = res.json().data;
        return new ResponseWrapper(res.headers, jsonResponse, res.status);
    }

    private convert(systemSetting: SystemSetting): SystemSetting {
        const copy: SystemSetting = Object.assign({}, systemSetting);
        return copy;
    }

    update(systemSetting: SystemSetting): Observable<SystemSetting> {
        const copy = this.convert(systemSetting);
        return this.http.post(`${this.resourceUpdateUrl}`, systemSetting).map((res: Response) => {
            if (!res || !res.json) {
                throw 'Invalid Code';
            }

            return res.json().data;
        });
    }
}
